import { Component, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { AppService } from '../../../shared/service/app/app.service';
import { AlertService } from './../../service/common/alert.service';
import { CommonService } from './../../service/common/common.service';

import { UserSendCodeDTO, UserDTO } from './../../dto/user.dto';
import { Codes } from './../../constants/messages/codes';
import { AuthService } from '../../service/auth/auth.service';

@Component({
  selector: 'app-comfirmation-message',
  templateUrl: './comfirmation-message.component.html',
  styleUrl: './comfirmation-message.component.css',
})
export class ConfirmationmessageComponent {
  @Input() user: UserSendCodeDTO | null = null;
  @Input() userComplete: UserDTO | null = null;

  showmodal: boolean = true;
  countdown: number = 5;
  verifycode: string = '';

  code1: string = '';
  code2: string = '';
  code3: string = '';
  code4: string = '';
  code5: string = '';
  code6: string = '';

  interval: any;
  store: any;
  failedAttempts: number = 0;
  maxAttempts: number = 5;
  currYear: number = new Date().getFullYear();

  constructor(
    public translate: TranslateService,
    public storeData: Store<any>,
    public router: Router,
    private appSetting: AppService,
    private alertService: AlertService,
    private commonService: CommonService,
    private authService: AuthService,
  ) {
    this.initStore();
  }
  onRegister() {
    // Muestra el modal
    this.showmodal = true;
    this.startCountdown();
  }
  ngOnInit() {
    this.startCountdown(); // Inicia el contador al abrir el modal
  }

  async initStore() {
    this.storeData
      .select((d) => d.index)
      .subscribe((d) => {
        this.store = d;
      });
  }
  async verifyCode() {
    // Validar que todos los campos estén completos
    if (!this.code1 || !this.code2 || !this.code3 || !this.code4 || !this.code5 || !this.code6) {
      this.alertService.error('Por favor ingrese el código completo de 6 dígitos');
      return;
    }

    // Concatenar los códigos para formar el código completo
    const enteredCode = `${this.code1}${this.code2}${this.code3}${this.code4}${this.code5}${this.code6}`;
    // console.log('Código ingresado:', enteredCode);

    if (this.user) {
      try {
        // Mostrar loading durante la validación
        this.alertService.showLoading('Verificando código...');

        const rsp = await this.commonService.validateSmsCode({ ...this.user, code: enteredCode });

        if (rsp.code.code === Codes.PTZ0000) {
          // Verificar si la respuesta contiene los campos phone_verified y needs_registration
          if (rsp.data && rsp.data.phone_verified && rsp.data.needs_registration) {
            // El teléfono está verificado pero el usuario necesita registrarse
            this.alertService.showLoading('Registrando usuario...');

            // Proceder con el registro del usuario
            const rspRegistre = await this.commonService.registerUser(this.userComplete as UserDTO);

            this.alertService.close();

            if (rspRegistre.code.code === Codes.PTZ0000) {
              this.alertService.success('Usuario registrado correctamente');
              this.showmodal = false;

              // Iniciar sesión automáticamente después del registro exitoso
              const userLogin = {
                email: this.userComplete!.email,
                password: this.userComplete!.password,
              };

              try {
                const rspLogin = await this.commonService.login(userLogin);

                if (rspLogin.code.code === Codes.PTZ0000) {
                  localStorage.setItem('secTkn', rspLogin.data.access_token);
                  this.authService.setAuthenticated(true);
                  this.router.navigate(['/profile']);
                } else {
                  // Si el login falla, mostrar el error pero no impedir que el usuario avance
                  this.alertService.error('Registro exitoso, pero hubo un problema al iniciar sesión automáticamente. Por favor, inicie sesión manualmente.');
                  setTimeout(() => {
                    this.router.navigate(['/login']);
                  }, 2000);
                }
              } catch (loginError) {
                console.error('Error en inicio de sesión automático:', loginError);
                this.alertService.error('Registro exitoso, pero hubo un problema al iniciar sesión automáticamente. Por favor, inicie sesión manualmente.');
                setTimeout(() => {
                  this.router.navigate(['/login']);
                }, 2000);
              }
            } else {
              this.alertService.error(rspRegistre.code.message['es'] || 'Error al registrar usuario');
            }
          } else if (rsp.data && rsp.data.access_token) {
            // El usuario ya existe y ha iniciado sesión correctamente
            this.alertService.close();
            this.alertService.success('Código verificado correctamente. Iniciando sesión...');
            localStorage.setItem('secTkn', rsp.data.access_token);
            this.authService.setAuthenticated(true);
            this.showmodal = false;
            setTimeout(() => {
              this.router.navigate(['/profile']);
            }, 1000);
          } else {
            // Comportamiento anterior para compatibilidad
            this.alertService.showLoading('Registrando usuario...');

            const rspRegistre = await this.commonService.registerUser(this.userComplete as UserDTO);

            this.alertService.close();

            if (rspRegistre.code.code === Codes.PTZ0000) {
              this.alertService.success('Usuario registrado correctamente');
              this.showmodal = false;
              const userLogin = {
                email: this.userComplete!.email,
                password: this.userComplete!.password,
              };
              const rspLogin = await this.commonService.login(userLogin);

              if (rspLogin.code.code === Codes.PTZ0000) {
                localStorage.setItem('secTkn', rspLogin.data.access_token);
                this.authService.setAuthenticated(true);
                this.router.navigate(['/profile']);
              }
            } else {
              this.alertService.error(rspRegistre.code.message['es'] || 'Error al registrar usuario');
            }
          }
        } else {
          this.alertService.close();
          this.failedAttempts++;
          this.alertService.error(rsp.code.message['es'] || 'Error al verificar código');
        }
      } catch (error: any) {
        this.alertService.close();
        console.error('Error al verificar el código:', error);

        // Manejar específicamente el error de "User not found with this phone number"
        if (error.error && error.error.response && error.error.response.message === 'User not found with this phone number') {
          // Intentar registrar al usuario directamente
          try {
            this.alertService.showLoading('Registrando usuario...');
            const rspRegistre = await this.commonService.registerUser(this.userComplete as UserDTO);

            this.alertService.close();

            if (rspRegistre.code.code === Codes.PTZ0000) {
              this.alertService.success('Usuario registrado correctamente');
              this.showmodal = false;
              setTimeout(() => {
                this.router.navigate(['/login']);
              }, 2000);
            } else {
              this.alertService.error(rspRegistre.code.message['es'] || 'Error al registrar usuario');
            }
          } catch (regError) {
            console.error('Error al registrar usuario:', regError);
            this.alertService.error('Error al registrar usuario. Intente nuevamente.');
          }
        } else {
          this.alertService.error('Error al validar el código. Intente nuevamente.');
        }
      }
    } else {
      this.alertService.error('Datos de usuario no disponibles. Intente nuevamente.');
    }
  }

  startCountdown() {
    this.countdown = 5;
    this.interval = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        clearInterval(this.interval);
      }
    }, 1000);
  }

  async resendCode() {
    if (this.failedAttempts >= this.maxAttempts) {
      this.alertService.error('Has excedido el número máximo de intentos');
      return;
    }

    try {
      // Resetear los códigos
      this.resetCode();

      // Mostrar indicador de carga
      this.alertService.showLoading('Enviando nuevo código...');

      if (this.user) {
        const response = await this.commonService.sendSmsCode(this.user);

        this.alertService.close();

        if (response.code.code === Codes.PTZ0000) {
          this.alertService.success('Código enviado correctamente');
          // Reiniciar contador
          this.startCountdown();
        } else {
          this.alertService.error(response.code.message['es'] || 'Error al enviar el código');
        }
      } else {
        this.alertService.close();
        this.alertService.error('No se pudo enviar el código. Intente nuevamente.');
      }
    } catch (error) {
      this.alertService.close();
      console.error('Error al reenviar el código:', error);
      this.alertService.error('Error al reenviar el código. Intente nuevamente.');
    }
  }

  closeModal() {
    const data = this.alertService.confirm('Are you sure you want to close');
    console.log(data);
    this.showmodal = false;
    clearInterval(this.interval);
  }

  changeLanguage(item: any) {
    this.translate.use(item.code);
    this.appSetting.toggleLanguage(item);
    if (this.store.locale?.toLowerCase() === 'ae') {
      this.storeData.dispatch({ type: 'toggleRTL', payload: 'rtl' });
    } else {
      this.storeData.dispatch({ type: 'toggleRTL', payload: 'ltr' });
    }
    // window.location.reload();
  }
  moveToNext(current: HTMLInputElement, next: HTMLInputElement | null) {
    if (current.value.length === 1 && next) {
      next.focus(); // Mueve el foco al siguiente input si hay un valor ingresado
    }
  }

  moveToPrev(event: KeyboardEvent, prevElement: ElementRef) {
    if (event.key === 'Backspace' && prevElement) {
      prevElement.nativeElement.focus();
    }
  }

  resetCode() {
    this.code1 = '';
    this.code2 = '';
    this.code3 = '';
    this.code4 = '';
    this.code5 = '';
    this.code6 = '';
  }
}
